<template>
  <div class="articleContent">
    <div class="title">
      <span class="title-sty">办事事项</span>
    </div>
    <ul class="InformationInquiry">
      <div
        v-for="(item, index) in processing"
        :key="item.value"
        :style="{ width: 100 / processing.length + '%' }"
        class="InformationInquiryItem"
        @click="eventBus(item.value)"
      >
        <li
          class="InformationInquiryItemLi"
          :class="{ 'is-active': activeValue == item.value }"
        >
          <span>{{ item.label }}</span>
        </li>
        <el-divider
          direction="vertical"
          v-if="index != processing.length - 1"
        ></el-divider>
      </div>
    </ul>
    <div class="announcement">
      <div class="calculation">
<!--        <span style="margin-right: 20px; font-size: 17px"-->
<!--          >共{{ matter }}个事项</span-->
<!--        >-->
        <span style="margin-right: 20px; font-size: 17px"
        >共{{ isShow.length }}个事项</span
        >
        <el-checkbox v-model="checked" @change="check()"
          >仅显示可在线办理事项</el-checkbox
        >
        <div
          class="matters_item"
          v-for="(item, index) in isShow"
          :key="index"
        >
          <div class="header">
            <div>
              <i class="el-icon-collection-tag"></i>
              {{ item.itemName }}
            </div>
            <div>
              <el-button
                      class="red-b"
                      v-if="item.hasBlzn == '1'"
                      @click="guideList(item)"
              >办事指南</el-button
              >
              <el-button class="red-b" v-if="item.hasZxbl == '1'" @click="dealOnline">
                <a
                        :href="jumpHandle"
                        target="_blank"
                        ref="dealOnline"
                >在线办理</a
                >
              </el-button>
              <el-button
                      class="red-b"
                      v-if="item.hasClxz == '1'"
                      @click="downloadList(item)"
              >资料下载</el-button
              >
              <el-button
                      class="red-b"
                      v-if="item.hasCjwt == '1'"
                      @click="problemList(item)"
              >常见问题</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {URL_EXAMINATION_AND_APPROVAL, URL_ISSHOW_BUSINESS_GUIDE, URL_FILE_DOWNLOAD} from "../../utils/api";
  import util from "../../utils/util";
  import {processing} from "../../utils/staticDict";
  import {frontHeater} from "../../utils/md5encryption";
  import { jumpHandle } from "../../utils/axiosUrl";

  export default {
  props: [],
  components: {},
  data() {
    return {
      jumpHandle: jumpHandle,
      activeValue: "",
      // 保存的状态用来判断在线办理
      staZx: "whole",
      processing: processing,
      // 计算事项
      matter: "0",
      //显示在线办事
      checked: false,
      mattersHandled: [],
      hasZxblList: [],
    };
  },
  computed: {
    isShow: function () {
      return this.mattersHandled.filter(item => {
        return item.itemCode !== '56020-b' && item.itemCode !== '56020-c' && item.itemCode !== '56014-3'
      })
    }
  },
  methods: {
    dealOnline () {
      this.$refs.dealOnline.click()
    },
    // 可显示在线办事
    check() {
      if (this.checked == true) {
        if (this.staZx == "whole") {
          this.getZxbsList(" ");
        }
        if (this.staZx == "culturalRelicsProtection") {
          this.getZxbsList("文物保护");
        }
        if (this.staZx == "archaeologicalExcavation") {
          this.getZxbsList("考古发掘");
        }
        if (this.staZx == "museumManagement") {
          this.getZxbsList("博物馆管理");
        }
        if (this.staZx == "culturalRelics") {
          this.getZxbsList("文物进出境");
        }
      } else {
        if (this.staZx == "whole") {
          this.getList(" ");
        }
        if (this.staZx == "culturalRelicsProtection") {
          this.getList("文物保护");
        }
        if (this.staZx == "archaeologicalExcavation") {
          this.getList("考古发掘");
        }
        if (this.staZx == "museumManagement") {
          this.getList("博物馆管理");
        }
        if (this.staZx == "culturalRelics") {
          this.getList("文物进出境");
        }
      }
    },
    // 请求列表数据
    getList(val) {
      let result = frontHeater([""], [""]);
      let Url = util.getAjaxUrl("axiosTWo");
      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      let params = {
        itemType: val,
      };
      this.$http
        .post(Url + URL_EXAMINATION_AND_APPROVAL, params)
        .then((resp) => {
          if (resp.status === 200) {
            this.mattersHandled = resp.data;
            this.matter = this.mattersHandled.length;
          }
        });
    },
    // 请求是否是在线办事
    getZxbsList(val) {
      let result = frontHeater(["status"], [status]);
      let Url = util.getAjaxUrl("axiosTWo");
      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      let params = {
        status: "1",
        itemType: val,
      };
      this.$http.post(Url + URL_ISSHOW_BUSINESS_GUIDE, params).then((resp) => {
        if (resp.status === 200) {
          this.mattersHandled = resp.data;
          this.matter = this.mattersHandled.length;
        }
      });
    },
    // 办事指南
    guideList(item) {
      console.log(item);
      this.$router.push({
        path: "/admin-license/exit-permits",
        query: { id: item.itemCode, type: item.itemName,hasZxbl:item.hasZxbl},
      });
    },
    // 资料下载
    downloadList(item) {
      let result = frontHeater(["status"], [status]);
      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
              result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
              result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      this.$util.ajaxWithFile(URL_FILE_DOWNLOAD + `?guidanceId=${item.itemCode}`, 'get',{},'axiosFour').then(res => {
        if (res.headers['content-disposition']) {
          let fileName = decodeURI(res.headers['content-disposition'].split(";")[1].split("=")[1]);
          this.$util.downloadFile(res.data,fileName)
        } else {
          this.$message.error('暂无文件')
        }
      })
    },
    // 常见问题
    problemList(item) {
      this.$router.push({
        path: "/admin-license/exit-permits",
        query: { id: item.itemCode, type: item.itemName, question: 1 },
      });
    },
    eventBus(value) {
      this.staZx = null;
      this.activeValue = value;
      this.checked = false;
      if (value == "whole") {
        this.getList(" ");
        this.staZx = value;
      }
      if (value == "culturalRelicsProtection") {
        this.getList("文物保护");
        this.staZx = value;
      }
      if (value == "archaeologicalExcavation") {
        this.getList("考古发掘");
        this.staZx = value;
      }
      if (value == "museumManagement") {
        this.getList("博物馆管理");
        this.staZx = value;
      }
      if (value == "culturalRelics") {
        this.getList("文物进出境");
        this.staZx = value;
      }
    },
  },
  mounted() {
    this.getList(" ");
    this.activeValue = this.processing.length ? this.processing[0].value : "";
  },
};
</script>
<style scoped lang='less'>
@import "../../styles/base";
@import "../../styles/comSty";
/deep/.el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: @theme-color;
  border-color: @theme-color;
}
/deep/.el-checkbox__input.is-focus .el-checkbox__inner {
  // background-color: red;
  border-color: @theme-color;
}
/deep/.el-checkbox__input.is-checked + .el-checkbox__label {
  color: @theme-color;
}
/deep/.el-checkbox__inner:hover {
  border-color: @theme-color;
}
.el-button + .el-button {
  margin-left: 10px;
}
.calculation {
  margin-top: 20px;
}
.InformationInquiry {
  display: flex;
  padding: 0 20px;
  margin-top: 20px;
  // margin: 20px 0;
  .InformationInquiryItem {
    display: flex;
    // border-bottom: 1px solid #dddddd;
    .InformationInquiryItemLi {
      list-style: none;
      padding: 5px 0 10px;
      font-size: 17px;
      text-align: center;
      width: 95%;
      cursor: pointer;
    }
    .is-active {
      color: @theme-color;
      font-weight: 700;
      border-bottom: 3px solid;
    }
    /deep/ .el-divider--vertical {
      background-color: #2c3e50;
      height: 1.6rem;
      margin: 10px 8px;
    }
  }
}
/deep/.el-range-editor.is-active,
.el-range-editor.is-active:hover {
  border-color: #b71c1c;
}
</style>
